import { Building2, Loader2, Stethoscope } from "lucide-react";

export type OpcaoDeClinica = { id: string; label: string };
type Dentista = { id: string; name: string };

const selectCls =
  "min-w-0 max-w-full cursor-pointer truncate rounded border-0 bg-transparent py-0.5 pl-0 pr-6 text-sm font-semibold text-zinc-900 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:cursor-default dark:bg-transparent dark:text-foreground [&>option]:bg-white dark:[&>option]:bg-card";

/**
 * Onde e com quem a consulta vai ser marcada, antes de tudo: confirma a unidade (problema real de
 * quem tem muitas clínicas) e deixa trocar ali mesmo. Trocar de clínica troca a organização ativa
 * de verdade — o diálogo volta pra de antes se a pessoa cancelar.
 */
export function CabecalhoDaConsulta({
  clinica,
  clinicaId,
  opcoesDeClinica,
  trocandoDeClinica,
  onTrocarClinica,
  dentistas,
  dentistaId,
  onDentista,
}: {
  clinica: string;
  clinicaId: string;
  /** Vazio ou uma só = mostra o nome, sem trocar (ex: editando uma consulta que já existe). */
  opcoesDeClinica: OpcaoDeClinica[];
  trocandoDeClinica: boolean;
  onTrocarClinica: (id: string) => void;
  dentistas: Dentista[];
  dentistaId: string | null;
  onDentista: (d: Dentista) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2 dark:border-border dark:bg-muted/40">
      <div className="flex min-w-0 items-center gap-1.5">
        {trocandoDeClinica ? (
          <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-zinc-400" />
        ) : (
          <Building2 className="h-3.5 w-3.5 shrink-0 text-zinc-400" />
        )}
        {opcoesDeClinica.length > 1 ? (
          <select
            aria-label="Clínica"
            className={selectCls}
            value={clinicaId}
            disabled={trocandoDeClinica}
            onChange={(e) => onTrocarClinica(e.target.value)}
          >
            {opcoesDeClinica.map((o) => (
              <option key={o.id} value={o.id}>
                {o.label}
              </option>
            ))}
          </select>
        ) : (
          <span className="truncate text-sm font-semibold text-zinc-900 dark:text-foreground">{clinica}</span>
        )}
      </div>

      {dentistas.length > 0 && (
        <div className="flex min-w-0 items-center gap-1.5">
          <Stethoscope className="h-3.5 w-3.5 shrink-0 text-zinc-400" />
          <select
            aria-label="Profissional"
            className={selectCls}
            value={dentistaId ?? ""}
            onChange={(e) => {
              const d = dentistas.find((x) => x.id === e.target.value);
              if (d) onDentista(d);
            }}
          >
            {dentistas.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
